import { Effect, Schema } from 'effect';

/**
 * The `User.GetFeatureFlags` response, kept for mobile app versions released
 * before `Flags.Get`. The API fills it from the flag list. Delete it, and the
 * endpoint, once the minimum supported app version reads `Flags.Get`.
 */
export const UserFeatureFlags = Schema.Struct({
  googleDrive: Schema.Boolean.pipe(
    Schema.withDecodingDefaultType(Effect.succeed(false)),
  ),
  googleDriveWeb: Schema.optionalKey(Schema.Boolean),
  dropbox: Schema.Boolean.pipe(
    Schema.withDecodingDefaultType(Effect.succeed(false)),
  ),
  cloudImports: Schema.Boolean,
});
export type UserFeatureFlags = typeof UserFeatureFlags.Type;
